export const API_KEY = process.env.REACT_APP_API_KEY;
export const API_BASE_URL = "https://api.themoviedb.org/3";

export const FETCH_DATA = "FETCH_DATA";
export const DATA_FETCHED = "DATA_FETCHED";
export const IS_FETCHING = "IS_FETCHING";
export const MARK_FAVOURITE = "MARK_FAVOURITE";

export const ADD_FAV_TO_LIST = "ADD_FAV_TO_LIST";
export const ADD_TO_WATCH_LIST = "ADD_TO_WATCH_LIST";

export const TOGGLE_LOADING_INDICATOR = "TOGGLE_LOADING_INDICATOR";
export const TOGGLE_ERROR_INDICATOR = "TOGGLE_ERROR_INDICATOR";

export const MOVIE_DB_BIO_LINK = "https://www.themoviedb.org/person";

export const genres = {
  "28": {
    id: 28,
    name: "Action"
  },
  "12": {
    id: 12,
    name: "Adventure"
  },
  "16": {
    id: 16,
    name: "Animation"
  },
  "35": {
    id: 35,
    name: "Comedy"
  },
  "80": {
    id: 80,
    name: "Crime"
  },
  "99": {
    id: 99,
    name: "Documentary"
  },
  "18": {
    id: 18,
    name: "Drama"
  },
  "10751": {
    id: 10751,
    name: "Family"
  },
  "14": {
    id: 14,
    name: "Fantasy"
  },
  "36": {
    id: 36,
    name: "History"
  },
  "27": {
    id: 27,
    name: "Horror"
  },
  "10402": {
    id: 10402,
    name: "Music"
  },
  "9648": {
    id: 9648,
    name: "Mystery"
  },
  "10749": {
    id: 10749,
    name: "Romance"
  },
  "878": {
    id: 878,
    name: "Science Fiction"
  },
  "10770": {
    id: 10770,
    name: "TV Movie"
  },
  "53": {
    id: 53,
    name: "Thriller"
  },
  "10752": {
    id: 10752,
    name: "War"
  },
  "37": {
    id: 37,
    name: "Western"
  }
};
